import { createContext } from "react";

const ValidatePDFContext = createContext();

export { ValidatePDFContext };
